import { render, staticRenderFns } from "./TextSlide.vue?vue&type=template&id=c9fb5c2a"
import script from "./TextSlide.vue?vue&type=script&lang=js"
export * from "./TextSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9fb5c2a')) {
      api.createRecord('c9fb5c2a', component.options)
    } else {
      api.reload('c9fb5c2a', component.options)
    }
    module.hot.accept("./TextSlide.vue?vue&type=template&id=c9fb5c2a", function () {
      api.rerender('c9fb5c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/TextSlide.vue"
export default component.exports